/**
 * The matrix chip vocabulary: one label and one colour triple per cell state.
 * Shared by `VisibilityMatrixCell`, which paints one chip per (object, view)
 * intersection, and `VisibilityMatrixLegend`, which samples the same chips — a
 * colour learned in the grid must read unchanged in the legend, so neither may
 * spell a label or pick a token of its own. `kit` / `group` / `both` are the
 * `MemberRowsScope` values other than `none`, so a cell indexes this map with
 * `state.memberRows` directly. `dashed` marks the two locked states, which have
 * no write path at all.
 */
import type { GlobalToken } from 'antd';
import type { VisibilityChip, VisibilityChipState } from './ViewVisibility.types';

export const visibilityChipVocabulary = (
    token: GlobalToken,
): Record<VisibilityChipState, VisibilityChip> => ({
    shown: {
        label: 'shown',
        color: token.colorPrimary,
        background: token.colorPrimaryBg,
        border: token.colorPrimaryBorder,
        dashed: false,
    },
    hidden: {
        label: 'hidden',
        color: token.colorTextTertiary,
        background: token.colorFillQuaternary,
        border: token.colorBorder,
        dashed: false,
    },
    kit: {
        label: 'kit blank',
        color: token.colorWarning,
        background: token.colorWarningBg,
        border: token.colorWarningBorder,
        dashed: false,
    },
    group: {
        label: 'group blank',
        color: token.colorWarning,
        background: token.colorWarningBg,
        border: token.colorWarningBorder,
        dashed: false,
    },
    both: {
        label: 'both blank',
        color: token.colorWarning,
        background: token.colorWarningBg,
        border: token.colorWarningBorder,
        dashed: false,
    },
    alwaysShown: {
        label: 'always',
        color: token.colorTextTertiary,
        background: token.colorBgContainer,
        border: token.colorBorder,
        dashed: true,
    },
    neverShown: {
        label: 'never',
        color: token.colorTextQuaternary,
        background: token.colorBgContainer,
        border: token.colorBorder,
        dashed: true,
    },
});
